export default __webpack_public_path__ + "static/media/designation-uncheck.458569bf.svg";